import type { Locale } from './index';

type DayKey = 'home.played' | 'home.listed' | 'board.validDays';
type Forms = Partial<Record<Intl.LDMLPluralRule, string>>;

// Unlisted forms use the locale's existing count-label wording, never English.
const forms: Partial<Record<Locale, Record<DayKey, Forms>>> = {
  en: {
    'home.played': { one: '{{count}} day played' },
    'home.listed': { one: '{{count}} day ranked' },
    'board.validDays': { one: '{{count}} valid day' },
  },
  ru: {
    'home.played': { one: 'Сыгран {{count}} день', few: 'Сыграно {{count}} дня', many: 'Сыграно {{count}} дней' },
    'home.listed': { one: '{{count}} день в рейтинге', few: '{{count}} дня в рейтинге', many: '{{count}} дней в рейтинге' },
    'board.validDays': { one: '{{count}} зачтённый день', few: '{{count}} зачтённых дня', many: '{{count}} зачтённых дней' },
  },
  es: {
    'home.played': { one: '{{count}} día jugado' },
    'home.listed': { one: '{{count}} día clasificado' },
    'board.validDays': { one: '{{count}} día válido' },
  },
  hi: {
    'home.played': { one: '{{count}} दिन खेला', zero: '{{count}} दिन खेले' },
    'home.listed': { one: '{{count}} दिन रैंक में' },
    'board.validDays': { one: '{{count}} मान्य दिन' },
  },
  fr: {
    'home.played': { one: '{{count}} jour joué' },
    'home.listed': { one: '{{count}} jour classé' },
    'board.validDays': { one: '{{count}} jour valide' },
  },
  de: {
    'home.played': { one: '{{count}} Tag gespielt' },
    'home.listed': { one: '{{count}} Tag gelistet' },
    'board.validDays': { one: '{{count}} gültiger Tag' },
  },
  pt: {
    'home.played': { one: '{{count}} dia jogado', zero: '{{count}} dias jogados' },
    'home.listed': { one: '{{count}} dia no ranking', zero: '{{count}} dias no ranking' },
    'board.validDays': { one: '{{count}} dia válido', zero: '{{count}} dias válidos' },
  },
};

export function dayPluralResources(locale: Locale, translation: Record<string, string>): Record<string, string> {
  return Object.fromEntries((['home.played', 'home.listed', 'board.validDays'] as const).flatMap(key =>
    [...new Set([...new Intl.PluralRules(locale).resolvedOptions().pluralCategories, ...Object.keys(forms[locale]?.[key] ?? {}) as Intl.LDMLPluralRule[]])].map(category => [
      `${key}_${category}`, forms[locale]?.[key]?.[category] ?? translation[key]!,
    ]),
  ));
}
